export default __webpack_public_path__ + "static/media/nimn.c9e423fa.png";